export default __webpack_public_path__ + "static/media/FrontEnd.f3f4af7b.png";